import { infiniteQueryOptions, queryOptions } from "@tanstack/react-query";
import {
  getFileContent,
  getFileContentPages,
} from "@/lib/data/requests/file-content";
export const fileContentQueryOptions = (id: string) =>
  queryOptions({
    queryKey: ["file-content", id],
    queryFn: () => getFileContent(id),
    refetchInterval: (query) =>
      query.state.error ||
      query.state.data?.processingId ||
      query.state.data?.status === "failed"
        ? false
        : 3000,
  });
export const fileContentPagesQueryOptions = (
  id: string,
  processingId: string,
) =>
  infiniteQueryOptions({
    queryKey: ["file-content-pages", id, processingId],
    queryFn: ({ pageParam }) =>
      getFileContentPages(id, processingId, pageParam),
    enabled: !!processingId,
    initialPageParam: undefined as string | undefined,
    getNextPageParam: (page) => page.nextCursor ?? undefined,
  });
